import React from 'react';
import PropTypes from 'prop-types';
import './style.scss'
import PhotosetCard from 'common/components/modules/photoset-card';
import CircleLoader from 'common/components/elements/loader/circle';
import EmptyState from 'common/components/modules/empty-states';
import AllMediaFilters from './filter-content';

import cx from 'classnames';
import ReorderingContent from 'admin/views/reorder-content';
import { createPortal } from 'react-dom';
import { CopyContentLink } from 'admin/utils/CopyContentLink';
import VideoCard from 'common/components/modules/video-card';
import VaultCard from '../vault/card';
import { getDrmVideoLicenseProxyUrl, getDrmVideoLicenseToken } from 'admin/api/AuthApi';

function AllMedia({
   data,
   onFilterChange,
   isEmpty,
   resources,
   isNewFetching,
   isFetchingByFilter,
   onClearAllFilters,
   emptyFilters,
   onSelectMedia,
   filters,
   siteUrl,
   selections,
   screenWidth,
   contentType,
   onDeleteMessag,
   updateMessage,
   isDemoMode,
   updateMessageUnlockDetails,
   checkAndUnlockDemoPublicSite,
}) {

   const desktopType = screenWidth > 768 ? 'descktop' : 'mobile'

   const onShare = (id) => {
      checkAndUnlockDemoPublicSite(() => {
         CopyContentLink(siteUrl, id, 'photoset');
      })
   }

   const view = (
      <div
         className={ cx({
            'flex justify-between media-list-header-inside-modal sm:px-6 pl-4 pr-2 pb-6': true,
         }) }
      >
         <div className='potosets-filtr-sorting z-20 flex-1 gap-4'>
            <AllMediaFilters
               onFilterChange={ (...arg) => {
                  onFilterChange(...arg)
               } }
               resources={ resources }
               desktopType={ desktopType }
               onClearAllFilters={ () => {
                  onClearAllFilters()
               }  }
               emptyFilters={ emptyFilters }
               contentType={ contentType }
               isMobile={ screenWidth <= 1024 }
               onSearchChange={ (value) => {
                  onFilterChange(value, 'search')
               } }
               filtersData={ filters }
            />
         </div>
      </div>
   )

   return (
      <div
         style={ {
            zIndex: 9,
         } }
         className={ cx({
            'relative photosets-list-container flex flex-col min-h-full': true,
            'justify-center': isEmpty && !isFetchingByFilter && screenWidth > 1024,
            'pb-8 max-ms:pb-6': !isFetchingByFilter && !isEmpty,
         }) }>
         {
            ['store', 'chat', 'related_content'].includes(contentType) && screenWidth > 1024 && !!document.getElementById('all_media-filter-content') ?
               createPortal(view, document.getElementById('all_media-filter-content'))
               : view
         }
         {
            !isFetchingByFilter && !!data?.length &&
               <ReorderingContent
                  contentType='photosets'
                  data={ data }
                  isInsideModal
                  screenWidth={ screenWidth }
               >
                  {
                     data.map((item, index) => {

                        let isFilteredByUnsent = filters?.chatContentStatus?.includes('unsent') || !filters?.chatContentStatus

                        if(item?.media_type === 'vault') {
                           let itemType = item.type === 'image' ? 'photo_vault' : 'video_vault'
                           return (
                              <VaultCard
                                 key={ item.id }
                                 data={ item }
                                 desktopType={ desktopType }
                                 selectCard={ () => {
                                    onSelectMedia([item])
                                 } }
                                 isChecked={ selections.find(it => item.id === it.id && it.type === itemType) }
                                 isInsideModal
                                 onDeleteMessag={ onDeleteMessag }
                                 updateVaultMessageAction={ (removedItem) => updateMessage({ ...removedItem, removedItemId: item.id, isFilteredByUnsent }) }
                                 updateMessageUnlockDetails={ updateMessageUnlockDetails }
                                 isMultipleSelect
                                 isDemoMode={ isDemoMode }
                              />
                           )
                        }

                        if(item?.media_type === 'video'){
                           return (
                              <VideoCard
                                 key={ item.id }
                                 data={ item }
                                 desktopType={ desktopType }
                                 isInsideModal
                                 isSelected={ selections.find(it => item.id === it.id && it.type === 'video') }
                                 onSelectThisVideo={  () => {
                                    onSelectMedia([item])
                                 } }
                                 siteUrl={ siteUrl }
                                 selectedItemsIds={ selections.map(it => it?.id) }
                                 isMultipleSelect
                                 onDeleteMessag={ onDeleteMessag }
                                 updateMessage={ (item) => updateMessage({ ...item, removedItemId: item.id, isFilteredByUnsent }) }
                                 contentType={ contentType }
                                 isDemoMode={ isDemoMode }
                                 updateMessageUnlockDetails={ updateMessageUnlockDetails }
                                 isMultipleAttachments
                                 onShare={ (pagename) => onShare(item.id, pagename) }
                                 originalContentStorageSettingsRoute='MY_SITE_CONTENT_STORAGE'
                                 getLicenseToken={ (drmType) => getDrmVideoLicenseToken(item.id, drmType) }
                                 getDrmVideoLicenseProxyUrl={ (drmType) => getDrmVideoLicenseProxyUrl(item.id, drmType) }
                              />
                           )
                        }

                        return (
                           <PhotosetCard
                              key={ item.id }
                              desktopType={ desktopType }
                              data={ item }
                              isInsideModal
                              isSelected={ selections.find(it => item.id === it.id && it.type === 'photoset') }
                              onSelectThisPhotoset={ () => {
                                 let modifiedItem = { ...item }
                                 const { cover_image, photos_src } = modifiedItem

                                 if(!!cover_image && photos_src?.length > 1 && photos_src?.[0] !== cover_image?.path) {
                                    let reorderedPhotosSrc = [...photos_src]
                                    const index = reorderedPhotosSrc.indexOf(cover_image?.path)
                                    if(index > -1) {
                                       reorderedPhotosSrc.splice(index, 1)
                                       reorderedPhotosSrc.unshift(cover_image?.path);
                                    }
                                    modifiedItem.photos_src = reorderedPhotosSrc
                                 }

                                 onSelectMedia([modifiedItem])
                              } }
                              siteUrl={ siteUrl }
                              selectedItemsIds={ selections.map(it => it?.id) }
                              isPinned={ item?.is_pinned }
                              isMultipleSelect
                              onDeleteMessag={ onDeleteMessag }
                              updateMessage={ (item) => {
                                 updateMessage({ ...item, removedItemId: item.id, isFilteredByUnsent })
                              } }
                              contentType={ contentType }
                              isDemoMode={ isDemoMode }
                              updateMessageUnlockDetails={ updateMessageUnlockDetails }
                              isMultipleAttachments
                              onShare={ () => onShare(item.id) }
                           />
                        )
                     })
                  }
               </ReorderingContent>
         }
         {
            isFetchingByFilter && (
               <div className='flex w-full justify-center items-center flex-1'>
                  <CircleLoader />
               </div>
            )
         }
         {
            isNewFetching && !isFetchingByFilter && (
               <div className='flex w-full h-20 justify-center items-center'>
                  <CircleLoader />
               </div>
            )
         }
         {
            isEmpty && !isFetchingByFilter && (
               <div className='flex items-center w-full flex-1'>
                  <EmptyState type='filter' />
               </div>
            )
         }
      </div>
   );
}

AllMedia.propTypes = {
   data: PropTypes.array,
   onFilterChange: PropTypes.func,
   isEmpty: PropTypes.bool,
   isFetchingByFilter: PropTypes.bool,
   resources: PropTypes.object,
   isNewFetching: PropTypes.bool,
   onClearAllFilters: PropTypes.func,
   emptyFilters: PropTypes.bool,
   onSelectMedia: PropTypes.func,
   filters: PropTypes.object,
   siteUrl: PropTypes.string,
   selections: PropTypes.array,
   screenWidth: PropTypes.number,
   contentType: PropTypes.string,
   onDeleteMessag: PropTypes.func,
   updateMessage: PropTypes.func,
   isDemoMode: PropTypes.bool,
   updateMessageUnlockDetails: PropTypes.func,
   checkAndUnlockDemoPublicSite: PropTypes.func,
}

export default AllMedia;
